'use client';

import React from 'react';

interface IStepper {
    initialStep: number;
    children: React.ReactElement<IStepperProps> | React.ReactElement[];
}

export interface IStepperProps {
    isActive: boolean;
    currentStep: number;
    onPrevStep(): void;
    onNextStep(): void;
    navigateTo(step: number): void;
}

export const Stepper: React.FC<IStepper> = ({ initialStep, children }) => {
    const [step, setStep] = React.useState(1);

    const handleSaveStep = (step: number) => setStep(step);
    const onNextStep = () => handleSaveStep(step + 1);
    const onPrevStep = () => handleSaveStep(step - 1);
    const isStepActive = (index: number) => index + 1 === step;
    const navigateToStep = React.useCallback((navigateStep: number) => handleSaveStep(navigateStep), [handleSaveStep]);

    React.useEffect(() => {
        if (initialStep) {
            navigateToStep(initialStep);
        }
    }, []);

    return (
        <>
            {React.Children.map(children, (child, index) => {
                return React.cloneElement(child as React.ReactElement<IStepperProps>, {
                    onNextStep,
                    onPrevStep,
                    currentStep: step,
                    isActive: isStepActive(index),
                    navigateTo: (step: number) => navigateToStep(step),
                });
            })}
        </>
    );
};
